// TODO - PÁGINA INICIAL

import { EMDESENVOLVIMENTO } from "../ImportBackend/Config/emDesenvolvimento"

// export const PAGINAINICIALEMDESENVOLVIMENTO: string = '/ContaCorrente'
export const LOGARBACKENDAPI: boolean = EMDESENVOLVIMENTO && false
export const LOGARBACKENDAPIRESULTADO: boolean = EMDESENVOLVIMENTO && false
// export const PAGINAINICIALEMDESENVOLVIMENTO: string = '/DashAgendamentos'
export const PAGINAINICIALEMDESENVOLVIMENTO: string = ''

export const LINK_INSTAGRAM_PAGINA_OBRIGADO: string = 'https://www.instagram.com/vamossorrir.mg'

export const LINK_FACEBOOK_PAGINA_OBRIGADO: string = 'https://www.facebook.com/vamossorrir.mg'

